import { render, staticRenderFns } from "./PhysicalNeonatus.vue?vue&type=template&id=6b2e9798&scoped=true"
import script from "./PhysicalNeonatus.vue?vue&type=script&lang=js"
export * from "./PhysicalNeonatus.vue?vue&type=script&lang=js"
import style0 from "./PhysicalNeonatus.vue?vue&type=style&index=0&id=6b2e9798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e9798",
  null
  
)

export default component.exports